module.exports = __webpack_public_path__ + "img/afval-fase-3.1161e236.png";